import * as actionsList from './actions'
import * as redux from './redux'

export * from './constants'

// @todo export * from redux
export const { epics, selectors } = redux

export const actions = { ...actionsList, ...redux.actions }

export { getState, getStateCurrent, default as reducer, registerReducer } from './reducer'
export { default as routes } from './routes'
export * from './schemas'
export { default as Edit } from './screens/Edit'
export { default as Fixture } from './screens/Fixture'
export { default as PermissionsScreen } from './screens/Permissions'
